export default __webpack_public_path__ + "static/media/team4@2x.af2c8e22.png";